import styled from "@emotion/styled";

const StatusPillStyled = styled.span`
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  font-size: ${(p) => p.theme.text.fontSizes.s};
  font-weight: 500;
`;

type Props = {
  label: string;
  color: string;
  backgroundColor: string;
};

export const StatusPill = ({ label, color, backgroundColor }: Props) => (
  <StatusPillStyled style={{ color, backgroundColor }}>
    {label}
  </StatusPillStyled>
);
